export default ({ data }) => {
  let {
    title,
    content,
    template,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
  } = data;

  if (template) {
    template = template
      .replace("{{title}}", title)
      .replace("{{content}}", content)
  }

  return (
    <div>
      {!!template ? (
        <section
          style={{
            paddingTop,
            paddingBottom,
            paddingRight,
            paddingLeft,
          }}
          dangerouslySetInnerHTML={{ __html: template }}
        ></section>
      ) : (
        <div>Default WeChat Text Image Block</div>
      )}
    </div>
  );
};
